import { render } from "./WarrantyDetailsDescription.vue?vue&type=template&id=012b78a6&scoped=true"
import script from "./WarrantyDetailsDescription.vue?vue&type=script&lang=js"
export * from "./WarrantyDetailsDescription.vue?vue&type=script&lang=js"

import "./WarrantyDetailsDescription.vue?vue&type=style&index=0&id=012b78a6&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012b78a6"]])

export default __exports__